<template>
  <div class="acr-main">
    <!-- 表格 -->
    <el-table :data="showTableData" border style="width: 100%" max-height="705px">
      <el-table-column prop="id" label="ID" width="330"></el-table-column>
      <el-table-column prop="propertyCode" label="资产密码" width="330"></el-table-column>
      <el-table-column label="状态" width="50">
        <template slot-scope="scope">
          <p>{{ scope.row.effectiveStatus === true ? '有效' : '无效' }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="propertyTypeName" label="资产类型归属" width="150"></el-table-column>
      <el-table-column prop="userName" label="归属用户" width="200"></el-table-column>
      <el-table-column prop="activationCodeId" label="归属兑换码" width="330"></el-table-column>
      <el-table-column prop="trackTime" label="最后修改日期" min-width="200"></el-table-column>
      <el-table-column fixed="right" label="操作" width="50">
        <template v-if="scope.row.effectiveStatus === true" slot-scope="scope">
          <el-button type="text" size="small" @click="invalidPropertyCode(scope.row.id)">失效</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination class="acr-pagination" @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   background layout="prev, pager, next" :page-size="11" :pager-count="5"
                   :total="propertyCodeTableData.length">
    </el-pagination>
  </div>
</template>

<script>

import AxiosBase from "@/components/axiosBase";

export default {
  name: "PropertyCodeTable",
  props: {
    propertyCodeTableData: Array
  },
  data() {
    return {
      showTableData: []
    }
  },
  beforeMount() {
    this.processTableData();
  },
  watch: {
    propertyCodeTableData: function () {
      this.processTableData();
    }
  },
  methods: {
    processTableData() {
      if (this.propertyCodeTableData.length > 11) {
        this.showTableData = this.propertyCodeTableData.slice(0, 11)
      } else {
        this.showTableData = this.propertyCodeTableData
      }
    },
    invalidPropertyCode(lvlId) {
      this.$confirm('此操作将会使激活码失效, 是否继续?', '激活码失效', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        AxiosBase.axiosDelete("/property-ad/invalid-property-code", {
          params: {
            id: lvlId
          }
        }).then(response => {
          if (response !== 0) {
            this.$parent.getPropertyCodeData();
            this.$message({
              type: 'success',
              message: response.data
            });
          }
        })
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      if (val === 1) {
        this.showTableData = this.propertyCodeTableData.slice(0, 11)
      } else {
        this.showTableData = this.propertyCodeTableData.slice((val - 1) * 11, (((val - 1) * 11) + 11))
      }
    },
  }
}
</script>

